"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _FlightPassengerSelector = _interopRequireDefault(require("../FlightPassengerSelector"));

var _ChinaDisclaimer = _interopRequireDefault(require("../ChinaDisclaimer"));

var _utilities = _interopRequireDefault(require("../../utilities"));

var _constant = require("../constant");

var _TextField = _interopRequireDefault(require("@airasia/phoenix-components/components/TextField"));

var _lodash = require("lodash");

var _CalendarWrapper = _interopRequireDefault(require("./CalendarWrapper"));

var _PlacePickerWrapper = _interopRequireDefault(require("./PlacePickerWrapper"));

var _PlacePickerCityGroupingWrapper = _interopRequireDefault(require("./PlacePickerCityGroupingWrapper"));

var _Modal = _interopRequireDefault(require("@airasia/phoenix-components/components/Modal"));

var _Banner = _interopRequireDefault(require("../Banner"));

var _useFetch11 = _interopRequireDefault(require("../Store/useFetch"));

var _dateFns = require("date-fns");

var _TripTypeSelector = _interopRequireDefault(require("@airasia/phoenix-components/components/TripTypeSelector"));

var _Checkbox = _interopRequireDefault(require("@airasia/phoenix-components/components/Checkbox"));

var _SnapCheckbox = _interopRequireDefault(require("../SnapCheckbox"));

var _ContextualSearchWidget = _interopRequireDefault(require("../ContextualSearchWidget"));

var _ButtonWrapper = _interopRequireDefault(require("./ButtonWrapper"));

var _flightSearchWidget = _interopRequireDefault(require("./flightSearchWidget.proptypes"));

var _constant2 = require("./constant");

var _data = require("./data");

var _utils = require("./utils");

var _utilities2 = require("./PlacePickerWrapper/utilities");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var USWContainer = _styledComponents.default.div.withConfig({
  displayName: "FlightSearchWidget__USWContainer",
  componentId: "sc-9n630u-0"
})(function (_ref) {
  var theme = _ref.theme,
      isMobile = _ref.isMobile,
      showBackGroundColor = _ref.showBackGroundColor,
      invertSearchButtonStyle = _ref.invertSearchButtonStyle;
  return "\n        display: flex;\n        flex-direction: column;\n        background-color: ".concat(theme.backgroundColor[showBackGroundColor], ";\n        #fsw-search-button-container{\n          & a {\n            background-color: ").concat(invertSearchButtonStyle ? theme.colors.default : theme.colors.primary, ";\n            ").concat(!isMobile && 'width: 184px;', "\n          }\n        }\n\n        ").concat(isMobile ? "\n            padding: 0 0;\n\n            #fsw-calendar{\n              & > div {\n                width: 100%;\n              }\n\n              #departclick-handle > div {\n                width: 100%;\n              }\n            }\n          " : "\n\n            #origin, #destination{\n              width: 100%;\n            }\n\n           .flex-auto{\n             flex: auto;\n           }\n\n            #flight-place-picker{\n              width: 100%;\n            }\n\n            #fsw-calendar{\n              width: 350px;\n\n              & > div{\n                width: 100%;\n              }\n\n              #departclick-handle > div {\n                width: 100%;\n              }\n\n              & #aaCalendar-header{\n                & > div{\n                  width: 100%;\n                }\n\n                & input{\n                  width: 100%;\n                }\n              }\n            }\n          ", "\n\n    ");
});

var USWRow = _styledComponents.default.div.withConfig({
  displayName: "FlightSearchWidget__USWRow",
  componentId: "sc-9n630u-1"
})(function (_ref2) {
  var theme = _ref2.theme,
      isMobile = _ref2.isMobile,
      isShowSnap = _ref2.isShowSnap;
  return "\n        display: flex;\n        flex: 1;\n\n        ".concat(isMobile && "\n            flex-direction: column;\n          ", "\n\n        ").concat(!isMobile && "\n            &:not(:last-child){\n                margin-bottom: ".concat(theme.space.small, ";\n            }\n            margin-bottom: ").concat(theme.space.small, ";\n          "), "\n\n        ").concat(!isMobile && isShowSnap && "\n            justify-content: space-between;\n            &:first-child {\n              margin-top: ".concat(theme.space.small, ";\n            }\n          "), "\n    ");
});

var PromoCodeContainer = _styledComponents.default.div.withConfig({
  displayName: "FlightSearchWidget__PromoCodeContainer",
  componentId: "sc-9n630u-2"
})(["display:", ";", ""], function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? 'block' : 'flex';
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile && "width: 100%";
});

var getContentStyles = function getContentStyles(theme, isMobile, isBanner) {
  if (isBanner && isMobile) return "padding: 0px";
  if (!isBanner && isMobile) return "padding: ".concat(theme.space.tiny, " ").concat(theme.space.small);
  if (!isBanner && !isMobile) return "&:not(:last-child){\n    margin-right: ".concat(theme.space.extraStandard, ";\n  }");
  return "";
};

var USWContent = _styledComponents.default.div.withConfig({
  displayName: "FlightSearchWidget__USWContent",
  componentId: "sc-9n630u-3"
})(function (_ref5) {
  var theme = _ref5.theme,
      isMobile = _ref5.isMobile,
      isBanner = _ref5.isBanner;
  return "\n        ".concat(isMobile ? "\n            flex: 1;\n          " : "\n            display: flex;\n          ", "\n        ").concat(getContentStyles(theme, isMobile, isBanner), "\n    ");
});

var Divider = _styledComponents.default.div.withConfig({
  displayName: "FlightSearchWidget__Divider",
  componentId: "sc-9n630u-4"
})(["width:2px;height:", ";background-color:", ";margin-left:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.lineHeight.titleSmall;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.greyMedium;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.extraStandard;
});

var TripTypeWrapper = _styledComponents.default.div.withConfig({
  displayName: "FlightSearchWidget__TripTypeWrapper",
  componentId: "sc-9n630u-5"
})(["display:flex;align-items:center;"]);

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "FlightSearchWidget__Wrapper",
  componentId: "sc-9n630u-6"
})(["", ""], function (_ref9) {
  var isMobile = _ref9.isMobile;
  return !isMobile && "display: flex !important;align-items: center;";
});

var FSWWrapper = _styledComponents.default.div.withConfig({
  displayName: "FlightSearchWidget__FSWWrapper",
  componentId: "sc-9n630u-7"
})(["", ";"], function (props) {
  return props.showBorder && !props.isMobile ? "\n  box-shadow: 0px 1px ".concat(props.theme.space.micro, " rgba(0, 0, 0, 0.16);\n  border-radius: 0px 0px ").concat(props.theme.borderRadius.normal, " ").concat(props.theme.borderRadius.normal, ";\n  padding: ").concat(props.theme.space.normal, ";\n  box-sizing: border-box;\n  ") : "";
});

var FlightSearchWidget = function FlightSearchWidget(props) {
  var _snapCheckBoxConfig$, _translations$;

  var data = props.data,
      viewport = props.viewport,
      onSubmit = props.onSubmit,
      theme = props.theme,
      environment = props.environment,
      endpointConfig = props.endpointConfig,
      locale = props.locale,
      geoid = props.geoid,
      currency = props.currency,
      enableDataVisor = props.enableDataVisor,
      isEdit = props.isEdit,
      preFill = props.preFill,
      enableLFC = props.enableLFC,
      enableLFCV2 = props.enableLFCV2,
      isLogin = props.isLogin,
      closeSearchWidget = props.closeSearchWidget,
      fireGtm = props.fireGtm,
      isSearchWidgetOpenByDefault = props.isSearchWidgetOpenByDefault,
      showContextualSearchWidget = props.showContextualSearchWidget,
      contextualConfig = props.contextualConfig,
      isShowSnapCheckbox = props.isShowSnapCheckbox,
      isShowSnapInNewWindow = props.isShowSnapInNewWindow,
      onValueChange = props.onValueChange,
      showBorder = props.showBorder,
      showBackGroundColor = props.showBackGroundColor,
      showIconBackground = props.showIconBackground,
      customSearchHandler = props.customSearchHandler,
      agentId = props.agentId,
      invertSearchButtonStyle = props.invertSearchButtonStyle,
      unifiedListingConfig = props.unifiedListingConfig,
      beforeRedirectHandler = props.beforeRedirectHandler,
      showMobileViewWithoutModal = props.showMobileViewWithoutModal,
      gtmParameters = props.gtmParameters,
      originOrDestinationNotFoundEventHandler = props.originOrDestinationNotFoundEventHandler,
      maxPromoLength = props.maxPromoLength,
      hasBanner = props.hasBanner,
      bannerData = props.bannerData,
      showCabinClass = props.showCabinClass,
      showMixClass = props.showMixClass,
      channelHash = props.channelHash,
      airlineProfile = props.airlineProfile,
      authToken = props.authToken,
      domain = props.domain,
      cityLevelGrouping = props.cityLevelGrouping,
      useV3Bucket = props.useV3Bucket,
      enableOnSearchCookieReset = props.enableOnSearchCookieReset,
      isAirAsiaFlightOnlyCheckbox = props.isAirAsiaFlightOnlyCheckbox,
      airAsiaFlightOnlyValueFromListing = props.airAsiaFlightOnlyValueFromListing,
      enableTravelSearchService = props.enableTravelSearchService,
      enableSuggestion = props.enableSuggestion;

  var _ref10 = data || _data.DEFAULT_DATA,
      components = _ref10.components,
      chinaDisclaimer = _ref10.chinaDisclaimer,
      aaiDisclaimer = _ref10.aaiDisclaimer,
      tripTypeConfig = _ref10.tripTypeConfig,
      passengerConfig = _ref10.passengerConfig,
      translations = _ref10.translations,
      calendarConfig = _ref10.calendarConfig,
      snapCheckBoxConfig = _ref10.snapCheckBoxConfig,
      travelClassConfig = _ref10.travelClassConfig;

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      origin = _useState2[0],
      setOriginObject = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      destination = _useState4[0],
      setDestinationObject = _useState4[1];

  var _useState5 = (0, _react.useState)({
    adult: 1,
    child: 0,
    infant: 0
  }),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      passengers = _useState6[0],
      setPassengersCount = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      promoCode = _useState8[0],
      setPromoCode = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      tripType = _useState10[0],
      setTripType = _useState10[1];

  var _useState11 = (0, _react.useState)({
    travelClass: _constant2.TRAVEL_CLASS.DEFAULT,
    mixedTravelClass: false
  }),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      travelClass = _useState12[0],
      setTravelClass = _useState12[1];

  var _useState13 = (0, _react.useState)({
    departureDate: null,
    returnDate: null
  }),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      tripDates = _useState14[0],
      setTripDates = _useState14[1];

  var _useState15 = (0, _react.useState)(true),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      destinationValid = _useState16[0],
      setDestinationValidState = _useState16[1];

  var _useState17 = (0, _react.useState)(null),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      chinaRedirectUrl = _useState18[0],
      setChinaRedirectUrl = _useState18[1];

  var _useState19 = (0, _react.useState)(null),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      aaiRedirectionUrl = _useState20[0],
      setAaiRedirectionUrl = _useState20[1];

  var _useState21 = (0, _react.useState)(!isSearchWidgetOpenByDefault && showContextualSearchWidget),
      _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
      openCSW = _useState22[0],
      setOpenCSW = _useState22[1];

  var _useState23 = (0, _react.useState)(endpointConfig || _data.DEFAULT_DATA.ENDPOINT_CONFIG[0].data),
      _useState24 = (0, _slicedToArray2.default)(_useState23, 2),
      endpointConfigToUse = _useState24[0],
      setEndpointConfigToUse = _useState24[1]; // eslint-disable-next-line no-unused-vars


  var _useFetch = (0, _useFetch11.default)({
    url: (0, _utils.formatEndpointURL)((0, _utils.getEndpointURL)(endpointConfigToUse, 'featureFlag'), environment, domain),
    method: _constant.HTTPS_METHOD.GET
  }, _constant2.ASYNC_DATA_KEYS.FEATURE_FLAG),
      _useFetch2 = (0, _slicedToArray2.default)(_useFetch, 2),
      featureFlag = _useFetch2[0],
      fetchFeatureFlag = _useFetch2[1];

  var exludeCityList = useV3Bucket && !cityLevelGrouping;
  var filterKey = exludeCityList ? _constant2.FILTER_TYPE.STATION_TYPE : null;
  var excludeParam = exludeCityList ? _constant2.STATION_TYPES.CITY : null; // eslint-disable-next-line no-unused-vars

  var _useFetch3 = (0, _useFetch11.default)(null, _constant2.ASYNC_DATA_KEYS.ORIGIN_STATIONS, filterKey, excludeParam, true // remove stations/cities with empty Dest value
  ),
      _useFetch4 = (0, _slicedToArray2.default)(_useFetch3, 2),
      originStationsList = _useFetch4[0],
      fetchOriginStations = _useFetch4[1];

  var _useFetch5 = (0, _useFetch11.default)(null, _constant2.ASYNC_DATA_KEYS.CALENDAR_DATA),
      _useFetch6 = (0, _slicedToArray2.default)(_useFetch5, 2),
      calendarDataFormat = _useFetch6[0],
      fetchCalendarDataFormat = _useFetch6[1];

  var _useFetch7 = (0, _useFetch11.default)(null, _constant2.ASYNC_DATA_KEYS.BASE_CURRENCY),
      _useFetch8 = (0, _slicedToArray2.default)(_useFetch7, 2),
      baseCurrency = _useFetch8[0],
      fetchBaseCurrency = _useFetch8[1]; // eslint-disable-next-line no-unused-vars


  var _useFetch9 = (0, _useFetch11.default)(null, _constant2.ASYNC_DATA_KEYS.MULTI_CURRENCY),
      _useFetch10 = (0, _slicedToArray2.default)(_useFetch9, 2),
      multiCurrency = _useFetch10[0],
      fetchMultiCurrency = _useFetch10[1];

  var _useState25 = (0, _react.useState)('false'),
      _useState26 = (0, _slicedToArray2.default)(_useState25, 2),
      showCnDisclaimer = _useState26[0],
      setShowCnDisclaimer = _useState26[1];

  var _useState27 = (0, _react.useState)('false'),
      _useState28 = (0, _slicedToArray2.default)(_useState27, 2),
      showAAIMessage = _useState28[0],
      setShowAAIMessage = _useState28[1];

  var _useState29 = (0, _react.useState)(false),
      _useState30 = (0, _slicedToArray2.default)(_useState29, 2),
      showTravelClass = _useState30[0],
      setShowTravelClass = _useState30[1];

  var _useState31 = (0, _react.useState)(viewport === _constant.DEVICE_TYPE.MOBILE),
      _useState32 = (0, _slicedToArray2.default)(_useState31, 2),
      isMobile = _useState32[0],
      setIsMobile = _useState32[1];

  var _useState33 = (0, _react.useState)(viewport === _constant.DEVICE_TYPE.MOBILE),
      _useState34 = (0, _slicedToArray2.default)(_useState33, 2),
      openModal = _useState34[0],
      setOpenModal = _useState34[1];

  var _useState35 = (0, _react.useState)(false),
      _useState36 = (0, _slicedToArray2.default)(_useState35, 2),
      qpSyncStations = _useState36[0],
      setQpSyncStations = _useState36[1];

  var _useState37 = (0, _react.useState)(null),
      _useState38 = (0, _slicedToArray2.default)(_useState37, 2),
      qpSyncOrigin = _useState38[0],
      setQpSyncOrigin = _useState38[1];

  var _useState39 = (0, _react.useState)(null),
      _useState40 = (0, _slicedToArray2.default)(_useState39, 2),
      qpSyncDestination = _useState40[0],
      setQpSyncDestination = _useState40[1];

  var _useState41 = (0, _react.useState)('false'),
      _useState42 = (0, _slicedToArray2.default)(_useState41, 2),
      aaiRedirectionFlag = _useState42[0],
      setAAIRedirectionFlag = _useState42[1];

  var _useState43 = (0, _react.useState)(false),
      _useState44 = (0, _slicedToArray2.default)(_useState43, 2),
      funnelServiceFlag = _useState44[0],
      setFunnelServiceFlag = _useState44[1];

  var _useState45 = (0, _react.useState)(true),
      _useState46 = (0, _slicedToArray2.default)(_useState45, 2),
      calendarDisableOneWay = _useState46[0],
      setCalendarDisableOneWay = _useState46[1];

  var _useState47 = (0, _react.useState)(false),
      _useState48 = (0, _slicedToArray2.default)(_useState47, 2),
      bigLoyaltyToggleValue = _useState48[0],
      setBigLoyaltyToggleValue = _useState48[1];

  var _useState49 = (0, _react.useState)(false),
      _useState50 = (0, _slicedToArray2.default)(_useState49, 2),
      airAsiaFlightOnlyValue = _useState50[0],
      setAirAsiaFlightOnlyValue = _useState50[1];

  var _useState51 = (0, _react.useState)(false),
      _useState52 = (0, _slicedToArray2.default)(_useState51, 2),
      isAvailableAirasiaFlight = _useState52[0],
      setIsAvailableAirasiaFlight = _useState52[1]; // the below flag is used for cabin class flight search widget toggle


  var _useState53 = (0, _react.useState)(false),
      _useState54 = (0, _slicedToArray2.default)(_useState53, 2),
      showFswCabinClass = _useState54[0],
      setShowFswCabinClass = _useState54[1];

  var _useState55 = (0, _react.useState)(false),
      _useState56 = (0, _slicedToArray2.default)(_useState55, 2),
      showFswMixedClass = _useState56[0],
      setShowFswMixedClass = _useState56[1]; // eslint-disable-next-line no-unused-vars


  var _useState57 = (0, _react.useState)(false),
      _useState58 = (0, _slicedToArray2.default)(_useState57, 2),
      bigLoyaltyCheckboxStatus = _useState58[0],
      setBigLoyaltyCheckboxStatus = _useState58[1];

  var _useState59 = (0, _react.useState)(false),
      _useState60 = (0, _slicedToArray2.default)(_useState59, 2),
      openCalendarModal = _useState60[0],
      setOpenCalendarModal = _useState60[1];

  var _useState61 = (0, _react.useState)(null),
      _useState62 = (0, _slicedToArray2.default)(_useState61, 2),
      localStoragePaxCount = _useState62[0],
      setLocalStoragePaxCount = _useState62[1];

  var _useState63 = (0, _react.useState)(null),
      _useState64 = (0, _slicedToArray2.default)(_useState63, 2),
      destinationSelectedObject = _useState64[0],
      setDestinationSelectedObject = _useState64[1];

  var _useState65 = (0, _react.useState)(null),
      _useState66 = (0, _slicedToArray2.default)(_useState65, 2),
      originSelectedObject = _useState66[0],
      setOriginSelectedObj = _useState66[1]; // eslint-disable-next-line no-unused-vars


  var _useState67 = (0, _react.useState)(passengerConfig && (0, _utils.constructPassengerData)(passengerConfig, translations, passengers) || _objectSpread(_objectSpread({}, _data.PASSENGER_STEPPER_CONFIG), {
    passengerCount: passengers
  })),
      _useState68 = (0, _slicedToArray2.default)(_useState67, 2),
      passengerData = _useState68[0],
      setPassengerData = _useState68[1];

  var _useState69 = (0, _react.useState)(false),
      _useState70 = (0, _slicedToArray2.default)(_useState69, 2),
      goToSnapToggle = _useState70[0],
      setGoToSnapToggle = _useState70[1];

  var _useState71 = (0, _react.useState)(null),
      _useState72 = (0, _slicedToArray2.default)(_useState71, 2),
      operatingAirline = _useState72[0],
      setOperatingAirline = _useState72[1];

  var _useState73 = (0, _react.useState)(false),
      _useState74 = (0, _slicedToArray2.default)(_useState73, 2),
      isDestinationCity = _useState74[0],
      setIsDestinationCity = _useState74[1];

  var _useState75 = (0, _react.useState)(false),
      _useState76 = (0, _slicedToArray2.default)(_useState75, 2),
      isOriginCity = _useState76[0],
      setIsOriginCity = _useState76[1];

  var getPrefillTripType = function getPrefillTripType() {
    if (preFill) return preFill.tripType ? preFill.tripType : null;
    var recentSearch = (0, _utilities2.getRecentSearches)();

    if (recentSearch && recentSearch.length > 0) {
      return recentSearch[0].tripType;
    }

    return _constant2.TRIP_TYPES.RETURN;
  }; // eslint-disable-next-line no-unused-vars


  var _useState77 = (0, _react.useState)(getPrefillTripType()),
      _useState78 = (0, _slicedToArray2.default)(_useState77, 2),
      preFillTripType = _useState78[0],
      setPreFillTripType = _useState78[1];

  var getPrefillDepartDate = function getPrefillDepartDate() {
    if (preFill) return preFill.depart ? preFill.depart : null;
    var recentSearch = (0, _utilities2.getRecentSearches)();

    if (recentSearch && recentSearch.length > 0) {
      return (0, _dateFns.format)(new Date(recentSearch[0].date.depart), _constant2.DATE_FORMAT.RECENT_SEARCH_FORMAT);
    }

    return null;
  };

  var getPrefillReturnDate = function getPrefillReturnDate() {
    if (preFillTripType === _constant2.TRIP_TYPES.RETURN) {
      if (preFill) return preFill.return ? preFill.return : null;
    }

    var recentSearch = (0, _utilities2.getRecentSearches)();

    if (recentSearch && recentSearch.length > 0 && recentSearch[0].tripType === _constant2.TRIP_TYPES.RETURN) {
      return (0, _dateFns.format)(new Date(recentSearch[0].date.return), _constant2.DATE_FORMAT.RECENT_SEARCH_FORMAT);
    }

    return null;
  }; // eslint-disable-next-line no-unused-vars


  var _useState79 = (0, _react.useState)(getPrefillDepartDate()),
      _useState80 = (0, _slicedToArray2.default)(_useState79, 2),
      preFillDepart = _useState80[0],
      setcalendarprefilldepart = _useState80[1]; // eslint-disable-next-line no-unused-vars


  var _useState81 = (0, _react.useState)(getPrefillReturnDate()),
      _useState82 = (0, _slicedToArray2.default)(_useState81, 2),
      preFillReturn = _useState82[0],
      setcalendarprefillreturn = _useState82[1];

  var cnDisclaimer = chinaDisclaimer[0].data[0];
  var inDisclaimer = aaiDisclaimer[0].data[0];
  var tripTypeData = tripTypeConfig && tripTypeConfig[0].data || _constant2.TRIP_TYPE_DATA;
  var maxDays = calendarConfig && calendarConfig[0].data[0].maxDays ? Number(calendarConfig[0].data[0].maxDays) : _constant2.MAX_DAYS;
  var snapDefaultCheckInRoutes = snapCheckBoxConfig && ((_snapCheckBoxConfig$ = snapCheckBoxConfig[0]) === null || _snapCheckBoxConfig$ === void 0 || (_snapCheckBoxConfig$ = _snapCheckBoxConfig$.data[0]) === null || _snapCheckBoxConfig$ === void 0 ? void 0 : _snapCheckBoxConfig$.originDestination);
  var bigLoyaltyLabel = translations[0].data[0].bigLoyaltyToggleLabel;
  var airAsiaOnlyCheckboxLabel = translations === null || translations === void 0 || (_translations$ = translations[0]) === null || _translations$ === void 0 || (_translations$ = _translations$.data) === null || _translations$ === void 0 || (_translations$ = _translations$[0]) === null || _translations$ === void 0 ? void 0 : _translations$.airAsiaOnly;
  var tripTypeMobileHeaderLabel = translations[0].data[0].tripTypeMobileHeaderLabel;
  var travelClassTranslation = travelClassConfig && travelClassConfig[0].data ? travelClassConfig[0].data.find(function (val) {
    return val.value === travelClass.travelClass;
  }).title : _constant2.TRAVEL_CLASS_CONFIG[0].data.find(function (val) {
    return val.value === travelClass.travelClass;
  }).title;
  var PassengerSelectionLabel = {
    flightPaxSelectorTitle: {
      single: translations[0].data[0].guestSingle,
      plural: translations[0].data[0].guestPlural
    },
    flightPaxSelectorWithTravelClassTitle: {
      single: "".concat(translations[0].data[0].guestSingle, " ").concat(travelClassTranslation),
      plural: "".concat(translations[0].data[0].guestPlural, " ").concat(travelClassTranslation)
    },
    doneButtonLabel: translations[0].data[0].roomSubmitButton,
    flightPaxSelectorMainTitle: translations[0].data[0].paxSelectorLabel,
    travelClassTitle: translations[0].data[0].travelClassTitle || _constant2.TRAVEL_CLASS_TITLE
  };
  var bannerUrl = translations[0].data[0].heroBannerUrl;
  var snapCheckboxTitle = translations[0].data[0].snapCheckboxTitle;
  var snapCheckboxLabel = translations[0].data[0].snapCheckboxLabel;
  var displaySnapCheckbox = isShowSnapCheckbox && operatingAirline === _constant2.AIRLINES.AAB && tripType === _constant2.TRIP_TYPES.RETURN;

  var promoCodeSemanticCheck = function promoCodeSemanticCheck(promoCodeString) {
    var regex = /^[0-9a-zA-Z ~!@#$%^&*-_+=|?]*[0-9a-zA-Z][0-9a-zA-Z ~!@#$%^&*-_+=|?]*$/;

    if (promoCodeString === undefined || promoCodeString === '') {
      return '';
    }

    if (promoCodeString.length >= 2 && promoCodeString.length <= 25 && promoCodeString.match(regex)) {
      return promoCodeString;
    }

    if (promoCodeString.length > 25) {
      return promoCodeString.slice(0, 25);
    }

    return '';
  };

  var setPromoCodeValue = function setPromoCodeValue(event) {
    setPromoCode(promoCodeSemanticCheck(event.target.value));
  };

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('chinadisclaimerclosed', function (e) {
        setShowCnDisclaimer("".concat(e.detail));
        setShowAAIMessage("".concat(e.detail));
      });
    }

    setEndpointConfigToUse(endpointConfig || _data.DEFAULT_DATA.ENDPOINT_CONFIG[0].data);
    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('chinadisclaimerclosed', function (e) {
          setShowCnDisclaimer("".concat(e.detail));
          setShowAAIMessage("".concat(e.detail));
        });
      }
    };
  }, [endpointConfig, environment]);
  (0, _react.useEffect)(function () {
    if (preFill) {
      if (Object.prototype.hasOwnProperty.call(preFill, 'depart')) {
        setcalendarprefilldepart(preFill.depart);
      }

      if (Object.prototype.hasOwnProperty.call(preFill, 'return')) {
        setcalendarprefillreturn(preFill.return);
      }

      if (Object.prototype.hasOwnProperty.call(preFill, 'promoCode')) {
        setPromoCode(promoCodeSemanticCheck(preFill.promoCode));
      }

      if (Object.prototype.hasOwnProperty.call(preFill, 'cabinClass')) {
        setTravelClass({
          travelClass: preFill.cabinClass,
          mixedTravelClass: false
        });
      }

      if (Object.prototype.hasOwnProperty.call(preFill, 'from') && Object.prototype.hasOwnProperty.call(preFill, 'to')) {
        if (preFill.from) setQpSyncOrigin(preFill.from);
        if (preFill.to) setQpSyncDestination(preFill.to);
        setQpSyncStations(true);
      }

      if (Object.prototype.hasOwnProperty.call(preFill, 'passengers')) {
        setPassengersCount(preFill.passengers);
        setPassengerData(passengerConfig && (0, _utils.constructPassengerData)(passengerConfig, translations, preFill.passengers) || _objectSpread(_objectSpread({}, _data.PASSENGER_STEPPER_CONFIG), {
          passengerCount: preFill.passengers
        }));
      }

      if (Object.prototype.hasOwnProperty.call(preFill, 'isDC')) {
        setIsDestinationCity(preFill.isDC);
      }

      if (Object.prototype.hasOwnProperty.call(preFill, 'isOC')) {
        setIsOriginCity(preFill.isOC);
      }
    }
  }, [passengerConfig, preFill, translations]);
  (0, _react.useEffect)(function () {
    if (!featureFlag) {
      return;
    }

    if (!featureFlag.data) {
      return;
    }

    if (!featureFlag.data || !featureFlag.data.configuration) {
      return;
    }

    if (featureFlag.data.configuration.ENABLE_AAI_REDIRECTION) {
      setAAIRedirectionFlag(featureFlag.data.configuration.ENABLE_AAI_REDIRECTION.toLowerCase());
    }

    if (featureFlag.data.configuration.ENABLE_FUNNEL_CONTROL_SERVICE) {
      setFunnelServiceFlag(featureFlag.data.configuration.ENABLE_FUNNEL_CONTROL_SERVICE.toLowerCase() === 'true');
    }

    if (featureFlag.data.configuration.ENABLE_FSW_CABIN_CLASS) {
      setShowFswCabinClass(featureFlag.data.configuration.ENABLE_FSW_CABIN_CLASS.toLowerCase() === 'true');
    }

    if (featureFlag.data.configuration.ENABLE_MIXED_CLASS) {
      setShowFswMixedClass(_utilities.default.checkStringBoolean(featureFlag.data.configuration.ENABLE_MIXED_CLASS));
    }
  }, [featureFlag]);
  var stationApiCallBasedOnLocale = (0, _react.useCallback)(function (lang) {
    var idValue = cityLevelGrouping || useV3Bucket ? _constant2.ORIGIN_CITY : _constant2.ORIGIN;
    var stationUrl = (0, _utils.formatEndpointURL)((0, _utils.getEndpointURL)(endpointConfigToUse, idValue), environment).replace('{locale}', lang);
    fetchOriginStations({
      url: stationUrl,
      method: _constant.HTTPS_METHOD.GET
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [endpointConfigToUse, environment, fetchOriginStations]);
  var dateFormatApiCallBasedOnLocale = (0, _react.useCallback)(function (lang) {
    var dateUrl = (0, _utils.formatEndpointURL)((0, _utils.getEndpointURL)(endpointConfigToUse, 'dateFormat'), environment).replace('{locale}', lang);
    fetchCalendarDataFormat({
      url: dateUrl,
      method: _constant.HTTPS_METHOD.GET
    });
  }, [endpointConfigToUse, environment, fetchCalendarDataFormat]);
  /**
   *@param otaRedirectionUrl handles the redirection for OTA for china. This requires showing a pop up.
   *
   * */

  var handleChinaRedirection = function handleChinaRedirection(otaRedirectionUrl) {
    if (_utilities.default.isChinaDomainName() && (!(origin !== null && origin !== void 0 && origin.AAFlight) || !(destination !== null && destination !== void 0 && destination.AAFlight))) {
      setChinaRedirectUrl(otaRedirectionUrl);
      setShowCnDisclaimer('true');
    } else window.open(otaRedirectionUrl, '_self');
  };

  (0, _react.useEffect)(function () {
    if (preFill && Object.prototype.hasOwnProperty.call(preFill, 'passengers') && preFill.passengers) {// console.log("Do pre-fill")
    } else if (localStoragePaxCount) {
      localStoragePaxCount.child = localStoragePaxCount.children;
      delete localStoragePaxCount.children;
      setPassengersCount(localStoragePaxCount);
      setPassengerData(passengerConfig && (0, _utils.constructPassengerData)(passengerConfig, translations, localStoragePaxCount) || _objectSpread(_objectSpread({}, _data.PASSENGER_STEPPER_CONFIG), {
        passengerCount: localStoragePaxCount
      }));
    }
  }, [localStoragePaxCount, passengerConfig, preFill, translations]);
  (0, _react.useEffect)(function () {
    stationApiCallBasedOnLocale(locale);
    dateFormatApiCallBasedOnLocale(locale);
    var recentSearches = localStorage.getItem('recentSearches');

    if (recentSearches !== null) {
      var recentSearchesStructure = JSON.parse(decodeURIComponent(localStorage.getItem('recentSearches')));

      if (recentSearchesStructure.length >= 0) {
        setLocalStoragePaxCount(recentSearchesStructure[0].passengers);
      }
    }
  }, [dateFormatApiCallBasedOnLocale, locale, stationApiCallBasedOnLocale]);
  (0, _react.useEffect)(function () {
    setIsMobile(viewport === _constant.DEVICE_TYPE.MOBILE);
  }, [viewport]);
  (0, _react.useEffect)(function () {
    if (typeof document !== 'undefined') {
      var placePicker = document.getElementById('flight-place-picker');
      placePicker.parentElement.classList.add('flex-auto');
    }
  }, []); // GTM when flight search widget loaded

  (0, _react.useEffect)(function () {
    var obj = {
      event: 'trackEventNoEcommerce',
      'eventDetails.category': 'hpsearchwidget - USW',
      'eventDetails.action': "view",
      'eventDetails.label': "Flights Widget Exposed"
    };
    if (obj && fireGtm) fireGtm(obj, 'true');
  }, [fireGtm]); // GTM when snap checkbox toggle

  (0, _react.useEffect)(function () {
    var obj = {
      event: 'trackEventNoEcommerce',
      'eventDetails.category': 'savings_checkbox',
      'eventDetails.action': 'click',
      'eventDetails.label': goToSnapToggle ? 'tick' : 'untick'
    };
    if (obj && fireGtm) fireGtm(obj, 'true');
  }, [goToSnapToggle, fireGtm]); // Callback to check form value changed

  (0, _react.useEffect)(function () {
    onValueChange({
      origin: origin,
      destination: destination,
      tripType: tripType,
      tripDates: tripDates,
      passengers: passengers,
      promoCode: promoCode,
      travelClass: travelClass
    });

    if (!origin) {
      return;
    }

    if (!destination) {
      return;
    }

    var airline = (0, _utils.getOperatingAirline)(origin, destination, cityLevelGrouping);
    setOperatingAirline(airline);

    if (airline === _constant2.AIRLINES.FLYBEYOND) {
      setShowTravelClass(true);
    } else {
      setShowTravelClass(false);
    }
  }, [origin, destination, tripType, tripDates, passengers, promoCode, onValueChange, travelClass]);

  var calendarWrapperOutput = function calendarWrapperOutput(val) {
    setTripDates({
      departureDate: val.dates.departureDate,
      returnDate: val.dates.returnDate
    });
  }; // opens calendar if destination selected


  var openCalendarFromPlacePicker = function openCalendarFromPlacePicker(val) {
    setOpenCalendarModal(val);
  }; // closes calendar when calendar component collapsed by action on calendar component


  var callbackOpenCalendarModal = function callbackOpenCalendarModal(val) {
    setOpenCalendarModal(val);
  };

  var tripTypeOutput = function tripTypeOutput(val) {
    if (val === _constant2.TRIP_TYPES.RETURN) {
      setCalendarDisableOneWay(true);
      setTripType(_constant2.TRIP_TYPES.RETURN);
    } else {
      setCalendarDisableOneWay(false);
      setTripType(_constant2.TRIP_TYPES.ONE_WAY);
    }
  };

  var isOriginValid = function isOriginValid(bool) {
    if (!bool) {
      setOriginObject(null);
      setDestinationObject(null);
      setIsDestinationCity(false);
      setIsOriginCity(false);
    }
  };

  var isDestinationValid = function isDestinationValid(bool) {
    setDestinationValidState(bool);
  };

  var returnStationType = function returnStationType(station) {
    var stationType = station && station.StationType ? station.StationType : station;
    return (0, _utils.isCity)(stationType);
  };

  var updateDestination = function updateDestination(code, station) {
    setDestinationObject(station);
    setIsDestinationCity(returnStationType(station));

    if (station && station.AAFlight) {
      setBigLoyaltyCheckboxStatus(false);
    } else if (station && !station.AAFlight) setBigLoyaltyCheckboxStatus(true);
  };

  (0, _react.useEffect)(function () {
    var _origin$airportCode, _destination$airportC;

    var originDes = "".concat((_origin$airportCode = origin === null || origin === void 0 ? void 0 : origin.airportCode) !== null && _origin$airportCode !== void 0 ? _origin$airportCode : origin === null || origin === void 0 ? void 0 : origin.StationCode, "-").concat((_destination$airportC = destination === null || destination === void 0 ? void 0 : destination.airportCode) !== null && _destination$airportC !== void 0 ? _destination$airportC : destination === null || destination === void 0 ? void 0 : destination.StationCode);

    if (tripType === _constant2.TRIP_TYPES.RETURN) {
      if (snapDefaultCheckInRoutes !== null && snapDefaultCheckInRoutes !== void 0 && snapDefaultCheckInRoutes.includes(originDes)) {
        setGoToSnapToggle(true);
      } else {
        setGoToSnapToggle(false);
      }
    } else {
      setGoToSnapToggle(false);
    }
  }, [origin, destination, tripType]);

  var updateOrigin = function updateOrigin(code, station) {
    setOriginObject(station);
    setIsOriginCity(returnStationType(station));

    if (station && station.AAFlight) {
      setBigLoyaltyCheckboxStatus(false);
      fetchBaseCurrency({
        url: (0, _utils.formatEndpointURL)((0, _utils.getEndpointURL)(endpointConfigToUse, 'baseCurrency'), environment, domain).replace('{IATA}', station.StationCode),
        method: _constant.HTTPS_METHOD.GET
      });
    } else if (station && !station.AAFlight) setBigLoyaltyCheckboxStatus(true);
  };

  (0, _react.useEffect)(function () {
    if (!baseCurrency) {
      return;
    }

    if (baseCurrency.isFetching || baseCurrency.isError) {
      return;
    }

    fetchMultiCurrency({
      url: (0, _utils.formatEndpointURL)((0, _utils.getEndpointURL)(endpointConfigToUse, 'multiCurrency'), environment, domain).replace('{currency}', baseCurrency.data),
      method: _constant.HTTPS_METHOD.GET
    });
  }, [baseCurrency, domain, endpointConfigToUse, environment, fetchMultiCurrency]);

  var onPaxSelectionDone = function onPaxSelectionDone(val) {
    setPassengersCount(val.paxCount);

    if (showFswCabinClass && (showTravelClass || showCabinClass) || showFswMixedClass && showMixClass) {
      setTravelClass({
        travelClass: val.travelClass,
        mixedTravelClass: val.mixedTravelClass
      });
    }
  };

  var setAaiRedirectionUrlCallback = function setAaiRedirectionUrlCallback(url) {
    setAaiRedirectionUrl(url);
  };

  var setShowAAIMessageCallback = function setShowAAIMessageCallback(value) {
    setShowAAIMessage(value);
  };

  var closeSearchWidgetMobile = function closeSearchWidgetMobile() {
    setOpenModal(false);
    if (closeSearchWidget && isMobile) closeSearchWidget();
  };

  var aaiRedirectionTimeout = function aaiRedirectionTimeout() {
    return setTimeout(function () {
      return window.open(aaiRedirectionUrl, '_blank');
    }, 4100);
  };

  (0, _react.useEffect)(function () {
    var isSelectStationDes = (destinationSelectedObject === null || destinationSelectedObject === void 0 ? void 0 : destinationSelectedObject.AAFlight) !== undefined;
    var isSelectStationOrigin = (originSelectedObject === null || originSelectedObject === void 0 ? void 0 : originSelectedObject.AAFlight) !== undefined;
    var isOnlyAirasiaOrigin = false;
    var isOnlyAirasiaDes = false;

    if (originStationsList !== null && originStationsList !== void 0 && originStationsList.data && Object.keys(originStationsList === null || originStationsList === void 0 ? void 0 : originStationsList.data).length > 0) {
      var _originStationsList$d, _originStationsList$d2, _originStationsList$d3, _originStationsList$d4;

      isOnlyAirasiaOrigin = isSelectStationOrigin ? originStationsList === null || originStationsList === void 0 || (_originStationsList$d = originStationsList.data) === null || _originStationsList$d === void 0 ? void 0 : _originStationsList$d.some(function (item) {
        return (item === null || item === void 0 ? void 0 : item.AAFlight) === true && (item === null || item === void 0 ? void 0 : item.StationCode) === (originSelectedObject === null || originSelectedObject === void 0 ? void 0 : originSelectedObject.StationCode);
      }) : originStationsList === null || originStationsList === void 0 || (_originStationsList$d2 = originStationsList.data) === null || _originStationsList$d2 === void 0 ? void 0 : _originStationsList$d2.some(function (item) {
        return (item === null || item === void 0 ? void 0 : item.AAFlight) === true && item.CityCode === (originSelectedObject === null || originSelectedObject === void 0 ? void 0 : originSelectedObject.CityCode);
      });
      isOnlyAirasiaDes = isSelectStationDes ? originStationsList === null || originStationsList === void 0 || (_originStationsList$d3 = originStationsList.data) === null || _originStationsList$d3 === void 0 ? void 0 : _originStationsList$d3.some(function (item) {
        return (item === null || item === void 0 ? void 0 : item.AAFlight) === true && (item === null || item === void 0 ? void 0 : item.StationCode) === (destinationSelectedObject === null || destinationSelectedObject === void 0 ? void 0 : destinationSelectedObject.StationCode);
      }) : originStationsList === null || originStationsList === void 0 || (_originStationsList$d4 = originStationsList.data) === null || _originStationsList$d4 === void 0 ? void 0 : _originStationsList$d4.some(function (item) {
        return (item === null || item === void 0 ? void 0 : item.AAFlight) === true && (item === null || item === void 0 ? void 0 : item.CityCode) === (destinationSelectedObject === null || destinationSelectedObject === void 0 ? void 0 : destinationSelectedObject.CityCode);
      });
    }

    var isCurrentAvailableAirasiaFlight = isOnlyAirasiaDes || isOnlyAirasiaOrigin;
    setIsAvailableAirasiaFlight(isCurrentAvailableAirasiaFlight);
  }, [destinationSelectedObject, originSelectedObject, originStationsList === null || originStationsList === void 0 ? void 0 : originStationsList.data]);

  var generateComponentWidget = function generateComponentWidget(compWidgetData, index, length) {
    var type = compWidgetData.type,
        label1 = compWidgetData.label1,
        label2 = compWidgetData.label2,
        label3 = compWidgetData.label3,
        label4 = compWidgetData.label4,
        placeholderText = compWidgetData.placeholderText;
    var accessible = true;

    var returnGroupedWrapper = function returnGroupedWrapper() {
      return /*#__PURE__*/_react.default.createElement(_PlacePickerCityGroupingWrapper.default, {
        theme: theme,
        viewport: viewport,
        environment: environment,
        setDestinationSelectedObjectFromProps: setDestinationSelectedObject,
        setOriginSelectedObjFromProps: setOriginSelectedObj,
        endpointConfig: endpointConfigToUse,
        locale: locale,
        updateOrigin: updateOrigin,
        updateDestination: updateDestination,
        isOriginStationValid: isOriginValid,
        isDestinationStationValid: isDestinationValid,
        qpSyncOrigin: qpSyncOrigin,
        qpSyncDestination: qpSyncDestination,
        qpSyncStations: qpSyncStations,
        openCalendarFromPlacePicker: openCalendarFromPlacePicker,
        originLabel: label3,
        destinationLabel: label4,
        translations: translations[0],
        fireGtm: fireGtm,
        tabIndex: 0,
        showIconBackground: showIconBackground,
        gtmParameters: gtmParameters,
        originOrDestinationNotFoundEventHandler: originOrDestinationNotFoundEventHandler,
        preFill: preFill,
        enableTravelSearchService: enableTravelSearchService,
        enableSuggestion: enableSuggestion
      });
    };

    var defaultPlacePicker = function defaultPlacePicker() {
      return /*#__PURE__*/_react.default.createElement(_PlacePickerWrapper.default, {
        theme: theme,
        setDestinationSelectedObjectFromProps: setDestinationSelectedObject,
        viewport: viewport,
        setOriginSelectedObjFromProps: setOriginSelectedObj,
        environment: environment,
        endpointConfig: endpointConfigToUse,
        locale: locale,
        updateOrigin: updateOrigin,
        updateDestination: updateDestination,
        isOriginStationValid: isOriginValid,
        isDestinationStationValid: isDestinationValid,
        qpSyncOrigin: qpSyncOrigin,
        qpSyncDestination: qpSyncDestination,
        qpSyncStations: qpSyncStations,
        openCalendarFromPlacePicker: openCalendarFromPlacePicker,
        originLabel: label1,
        destinationLabel: label2,
        translations: translations[0],
        fireGtm: fireGtm,
        tabIndex: 0,
        showIconBackground: showIconBackground,
        gtmParameters: gtmParameters,
        originOrDestinationNotFoundEventHandler: originOrDestinationNotFoundEventHandler,
        cityLevelGrouping: cityLevelGrouping,
        useV3Bucket: useV3Bucket
      });
    };

    switch (type) {
      case _constant2.USW_COMPONENT_TYPES.HERO_BANNER:
        if (!showMobileViewWithoutModal) return /*#__PURE__*/_react.default.createElement(_Banner.default, {
          showBackNavigation: true,
          backNavigationHandler: closeSearchWidgetMobile,
          imageURL: bannerUrl,
          height: "154px",
          theme: theme
        });
        return null;

      case _constant2.USW_COMPONENT_TYPES.PLACEPICKER:
        return cityLevelGrouping ? returnGroupedWrapper() : defaultPlacePicker();

      case _constant2.USW_COMPONENT_TYPES.DATEPICKER:
        return /*#__PURE__*/_react.default.createElement(_CalendarWrapper.default, {
          theme: theme,
          viewport: viewport,
          disableOneWay: calendarDisableOneWay,
          calendarWrapperOutput: calendarWrapperOutput,
          calendarModalOpen: openCalendarModal,
          callbackOpenCalendarModal: callbackOpenCalendarModal,
          dateFormatData: calendarDataFormat && !calendarDataFormat.isFetching && !calendarDataFormat.isError ? calendarDataFormat.data : null,
          labelDepart: label1,
          labelReturn: label2,
          translations: translations[0],
          calendarProps: {
            lfcConfig: {
              member: isLogin ? _constant2.LFC_MEMBER.LOGGEDIN.toString() : _constant2.LFC_MEMBER.ANONYMOUS.toString(),
              role: isMobile ? _constant2.LFC_ROLE.MOBILE.toString() : _constant2.LFC_ROLE.DESKTOP.toString(),
              currency: currency,
              baseCurrency: baseCurrency === null || baseCurrency === void 0 ? void 0 : baseCurrency.data,
              origin: origin === null || origin === void 0 ? void 0 : origin.StationCode,
              destination: destination === null || destination === void 0 ? void 0 : destination.StationCode,
              departDate: tripDates.departureDate,
              returnDate: tripDates.returnDate,
              triptype: tripType,
              channelHash: channelHash,
              userType: isLogin ? _constant2.LFC_MEMBER_V2.LOGGEDIN : _constant2.LFC_MEMBER_V2.ANONYMOUS,
              airlineProfile: airlineProfile,
              authToken: authToken,
              isDestinationCity: isDestinationCity.toString() || (0, _utils.isCity)(destination).toString(),
              isOriginCity: isOriginCity.toString() || (0, _utils.isCity)(origin).toString()
            },
            environment: environment,
            enableLFC: Boolean(enableLFC && (origin === null || origin === void 0 ? void 0 : origin.AAFlight) && (destination === null || destination === void 0 ? void 0 : destination.AAFlight)),
            enableLFCV2: Boolean(enableLFCV2)
          },
          prefillDefaultDepart: preFillDepart,
          prefillDefaultReturn: preFillReturn,
          preFillTripType: preFillTripType,
          tabIndex: 0,
          maxDays: maxDays
        });

      case _constant2.USW_COMPONENT_TYPES.PAX_COUNTER:
        return /*#__PURE__*/_react.default.createElement(Wrapper, {
          isMobile: isMobile
        }, /*#__PURE__*/_react.default.createElement(_FlightPassengerSelector.default, {
          passengerStepperConfig: passengerData,
          travelClassConfig: travelClassConfig[0].data,
          defaultTravelClass: preFill && preFill.cabinClass ? preFill.cabinClass : travelClass.travelClass,
          isMobile: isMobile,
          onDone: onPaxSelectionDone,
          theme: theme,
          translations: PassengerSelectionLabel,
          showTravelClass: showTravelClass || showCabinClass,
          showMixClassCheckbox: showFswMixedClass || showMixClass,
          hasBanner: hasBanner,
          bannerData: bannerData
        }), index !== length - 1 && !isMobile ? /*#__PURE__*/_react.default.createElement(Divider, null) : null);

      case _constant2.USW_COMPONENT_TYPES.MULTI_ROOM_SELECT:
        return null;

      case _constant2.USW_COMPONENT_TYPES.TRIP_TYPE:
        return /*#__PURE__*/_react.default.createElement(TripTypeWrapper, null, /*#__PURE__*/_react.default.createElement(_TripTypeSelector.default, {
          accessible: accessible,
          viewType: viewport,
          data: tripTypeData,
          tripTypeOutput: tripTypeOutput,
          prefillTripTypeCode: preFillTripType,
          mobileHeaderLabel: tripTypeMobileHeaderLabel
        }), index !== length - 1 && !isMobile ? /*#__PURE__*/_react.default.createElement(Divider, null) : null);

      case _constant2.USW_COMPONENT_TYPES.DROPDOWN:
        return null;

      case _constant2.USW_COMPONENT_TYPES.PROMOCODE:
        return /*#__PURE__*/_react.default.createElement(Wrapper, {
          isMobile: isMobile
        }, /*#__PURE__*/_react.default.createElement(PromoCodeContainer, {
          isMobile: isMobile
        }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
          id: "home_promocode",
          label: placeholderText,
          alwaysShowLabel: false,
          theme: theme,
          onChange: setPromoCodeValue,
          variableWidth: isMobile && '100%',
          value: promoCode,
          variableHeight: !isMobile && '40px',
          maxInputLength: maxPromoLength,
          customProperties: {
            'aria-label': "".concat(placeholderText, ". Actionable Left click or press enter")
          }
        })), index !== length - 1 && !isMobile ? /*#__PURE__*/_react.default.createElement(Divider, null) : null);

      case _constant2.USW_COMPONENT_TYPES.LINK:
        return null;

      case _constant2.USW_COMPONENT_TYPES.CHECKBOX:
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isAirAsiaFlightOnlyCheckbox ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isAvailableAirasiaFlight && /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
          theme: theme,
          isSelected: airAsiaFlightOnlyValue,
          onChange: setAirAsiaFlightOnlyValue,
          text: airAsiaOnlyCheckboxLabel,
          disableBottomMargin: true,
          customProperties: {
            id: "home_airasiaflights"
          }
        })) : /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
          theme: theme,
          isSelected: bigLoyaltyToggleValue,
          onChange: setBigLoyaltyToggleValue,
          disableCheckbox: bigLoyaltyCheckboxStatus,
          text: bigLoyaltyLabel,
          disableBottomMargin: true,
          customProperties: {
            'aria-label': "Bigpoints redemption checkbox ".concat(bigLoyaltyToggleValue === true ? 'selected' : 'deselected', ".")
          },
          textCustomProperties: {
            'aria-hidden': true
          }
        }));

      case _constant2.USW_COMPONENT_TYPES.SNAP_CHECKBOX:
        if (displaySnapCheckbox) return /*#__PURE__*/_react.default.createElement(Wrapper, {
          isMobile: isMobile
        }, /*#__PURE__*/_react.default.createElement(_SnapCheckbox.default, {
          theme: theme,
          isSelected: goToSnapToggle,
          onChange: setGoToSnapToggle,
          titleText: snapCheckboxTitle || label1,
          text: snapCheckboxLabel || label2
        }));
        return null;

      case _constant2.USW_COMPONENT_TYPES.BUTTON:
        return /*#__PURE__*/_react.default.createElement(_ButtonWrapper.default, {
          buttonId: "home_Search",
          isAirasiaFlightOnly: airAsiaFlightOnlyValueFromListing || airAsiaFlightOnlyValue,
          theme: theme,
          invertSearchButtonStyle: invertSearchButtonStyle,
          label: label1,
          origin: origin,
          destinationValid: destinationValid,
          destination: destination,
          tripDates: tripDates,
          tripType: tripType,
          funnelServiceFlag: funnelServiceFlag,
          isMobile: isMobile,
          passengers: passengers,
          promoCode: promoCode,
          showFswCabinClass: showFswCabinClass,
          showTravelClass: showTravelClass || showCabinClass,
          travelClass: travelClass,
          currency: currency,
          geoid: geoid,
          locale: locale,
          unifiedListingConfig: unifiedListingConfig,
          environment: environment,
          customSearchHandler: customSearchHandler,
          fireGtm: fireGtm,
          gtmParameters: gtmParameters,
          operatingAirline: operatingAirline,
          onSubmit: onSubmit,
          beforeRedirectHandler: beforeRedirectHandler,
          isEdit: isEdit,
          aaiRedirectionFlag: aaiRedirectionFlag,
          setShowAAIMessageCallback: setShowAAIMessageCallback,
          setAaiRedirectionUrlCallback: setAaiRedirectionUrlCallback,
          goToSnapToggle: goToSnapToggle,
          bigLoyaltyToggleValue: bigLoyaltyToggleValue,
          agentId: agentId,
          handleChinaRedirection: handleChinaRedirection,
          isLogin: isLogin,
          endpointConfig: endpointConfigToUse,
          enableDataVisor: enableDataVisor,
          isShowSnapInNewWindow: isShowSnapInNewWindow,
          domain: domain,
          cityLevelGrouping: cityLevelGrouping,
          enableOnSearchCookieReset: enableOnSearchCookieReset
        });

      default:
        return null;
    }
  };

  generateComponentWidget.propTypes = _flightSearchWidget.default.PropTypes;

  var checkElementVisibility = function checkElementVisibility(d, index, length) {
    var showInDesktop = d.showInDesktop,
        showInMobile = d.showInMobile; // Check if component/widget will be visible to mobile

    if (isMobile) {
      if (_utilities.default.checkStringBoolean(showInMobile)) {
        return generateComponentWidget(d, index, length);
      }
    } else {
      if (_utilities.default.checkStringBoolean(showInDesktop)) {
        return generateComponentWidget(d, index, length);
      }

      return null;
    }

    return null; // Check if component/widget will be visible to desktop
  };

  var searchWidgetInteractHandler = function searchWidgetInteractHandler() {
    if (!isSearchWidgetOpenByDefault) {
      return;
    }

    setOpenCSW(true);
  };

  var getContainer = function getContainer() {
    return /*#__PURE__*/_react.default.createElement(FSWWrapper, {
      showBorder: showBorder,
      isMobile: isMobile,
      id: showBorder && !isMobile ? 'fsw-wrapper-with-border' : 'fsw-wrapper'
    }, /*#__PURE__*/_react.default.createElement(USWContainer, {
      isMobile: isMobile,
      onClick: searchWidgetInteractHandler,
      showBackGroundColor: showBackGroundColor,
      invertSearchButtonStyle: invertSearchButtonStyle
    }, // eslint-disable-next-line react/prop-types
    components.map(function (comp, index) {
      var compData = comp["data".concat(index)];
      return /*#__PURE__*/_react.default.createElement(USWRow, {
        id: "row-".concat(index),
        isMobile: isMobile,
        isShowSnap: displaySnapCheckbox
      }, compData.map(function (d, i) {
        var ele = checkElementVisibility(d, i, compData.length);

        if (ele === null) {
          return _lodash.isNull;
        }

        return /*#__PURE__*/_react.default.createElement(USWContent, {
          isMobile: isMobile,
          isBanner: d.type === _constant2.USW_COMPONENT_TYPES.HERO_BANNER
        }, ele);
      }));
    }), openCSW && showContextualSearchWidget && /*#__PURE__*/_react.default.createElement(_ContextualSearchWidget.default, (0, _extends2.default)({}, contextualConfig, {
      config: _objectSpread(_objectSpread({}, contextualConfig.config), {}, {
        geoid: geoid,
        product: _constant2.DEFAULT_CONTEXTUAL_PRODUCT_ID,
        viewport: viewport
      })
    }))), showCnDisclaimer === 'true' && /*#__PURE__*/_react.default.createElement(_ChinaDisclaimer.default, {
      content: [cnDisclaimer],
      productId: "flights",
      theme: theme,
      redirect: chinaRedirectUrl
    }), showAAIMessage === 'true' && aaiRedirectionTimeout() && /*#__PURE__*/_react.default.createElement(_ChinaDisclaimer.default, {
      content: [inDisclaimer],
      productId: "flights",
      theme: theme,
      redirect: aaiRedirectionUrl,
      noRedirection: true
    }));
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, viewport === 'mobile' && !showMobileViewWithoutModal ? /*#__PURE__*/_react.default.createElement(_Modal.default, {
      openModal: openModal,
      viewPort: viewport,
      fullScreen: true,
      showCloseIcon: false,
      zIndex: 12
    }, getContainer()) : getContainer());
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

FlightSearchWidget.propTypes = _flightSearchWidget.default.PropTypes;
FlightSearchWidget.defaultProps = _flightSearchWidget.default.DefaultProps;
var _default = FlightSearchWidget;
exports.default = _default;